<template>
	<div class="choose-fee-container">
		<div class="content">
			<mobile-card>
				<template slot="title">
					<span>{{selectItem.itemName}}</span>
				</template>
				<template slot="content">

					<!-- range -->
					<div class="flex-form-info" v-if="selectIntervalName">
						<span>交费区间</span>
						<span @click="selectRange" class="custom-select-item">
							{{ model.rangeName | formatSelectSpaceText }}
							<van-icon name="arrow-down" />
						</span>
					</div>
					<div class="flex-form-info" v-else>
						<span>交费区间</span>
						<span>{{ model.rangeName | formatSpaceText }}</span>
					</div>

					<!-- price -->
					<div class="flex-form-info" v-if="selectMoney">
						<span>{{ selectItem.canChangeCount ? '单价':'收费金额'}}</span>
						<span class="money-item" @click="selectPrice">
							{{ model.name + '('+ formatMoney(model.money) +')'}}
							<van-icon name="arrow-down" />
						</span>
					</div>

					<div class="flex-form-info" v-else-if="editMoney">
						<span>{{ selectItem.canChangeCount ? '单价':'收费金额'}}</span>
						<span class="input-border" :data-tootik="editMoneyPlaceholder">
							<!-- <van-field v-model="model.money" clearable type="number" input-align="right" ></van-field> -->
							<!-- 只有feeMode 为3 普通费用（交费人自填金额）时才有用户自主交费上限，并且maxMoney不为空大于0才有意义 -->
							<vue-numeric v-model="model.money" v-if="selectItem.feeMode === 3 && selectItem.maxMoney" :max="selectItem.maxMoney" :precision="2" class="money-input"></vue-numeric>
							<vue-numeric v-model="model.money" v-else :precision="2" class="money-input"></vue-numeric>
						</span>
					</div>

					<div class="flex-form-info" v-else>
						<span>{{ selectItem.canChangeCount ? '单价':'收费金额'}}</span>
						<span class="money-item">{{model.money | formatMoney}}</span>
					</div>

					<div class="flex-form-info" v-if="editCount">
						<span>数量</span>
						<van-stepper v-model="model.count" />
					</div>
				</template>
			</mobile-card>
		</div>
		<div class="footer">
			<choose-fee-footer :model="model" @commit="onCommit"></choose-fee-footer>
		</div>

		<van-popup v-model="showRangePicker" position="bottom">
			<van-picker
				show-toolbar
				:columns="intervalArray"
				:default-index="defaultIndex"
				@cancel="showRangePicker = false"
				@confirm="onConfirm"
			></van-picker>
		</van-popup>

		<van-popup v-model="showMoneyPicker" position="bottom">
			<van-picker
				show-toolbar
				:columns="moneyArray"
				:default-index="defaultIndex2"
				@cancel="showMoneyPicker = false"
				@confirm="onConfirm2"
			></van-picker>
		</van-popup>
	</div>
</template>

<script>
	import log from "utils/log";
	// import { getState, setState } from "utils/state";
	import storage from 'good-storage'
	import MobileCard from "components/mobile-card/index";
	import ChooseFeeFooter from "./anonymous-pay-footer/index";
	import apiChooseFee from "api/anonymous-pay";
	import utils from "utils/util";

	export default {
		name:'chooseFeeDetail',
		components: { ChooseFeeFooter, MobileCard },
		data() {
			return {
				selectItem: {},
				showRangePicker: false,
				defaultIndex: 0,
				showMoneyPicker: false,
				defaultIndex2: 0,
				model: {
					rangeName: "",
					range: null,
					name:"",
					money: 0,
					count: 1,
					remark: "",
					enableUseCompanyTitle: false
				},
				editMoneyPlaceholder:"",
			};
		},
		computed: {
			sumMoney() {
				let { money, count } = this.model;
				money = Number(money);
				count = Number(count);
				return money * count;
			},

			selectIntervalName() {
				// 判断是不是多区间
				let r = Array.isArray(this.selectItem.intervals) && this.selectItem.intervals.length > 1;
				return r;
			},

			selectMoney() { // 计费方式：自选标准
				// feeMode为2: 普通费用（交费人自选标准）
				// let r = Array.isArray(this.selectItem.moneys) && this.selectItem.moneys.length > 1;
				// return r;
				return this.selectItem.feeMode === 2
			},

			// 是否显示数量
            editCount() {
                return this.selectItem.canChangeCount
            },

			editMoney() { // 计费方式：自填金额
				// feeMode为3: 普通费用（交费人自填金额）
				// return this.selectItem.feeMode === 3 || this.selectItem.editMoney;
				if(this.selectItem.feeMode === 3 || this.selectItem.editMoney) {
					return true
				} else {
					return false
				}
			},

			// intervalName() {
			// 	if (Array.isArray(this.selectItem.intervals) && this.selectItem.intervals.length === 1) {
			// 		return this.selectItem.intervals[0].intervalName;
			// 	} else {
			// 		return "--";
			// 	}
			// },

			intervalArray() {
				if (this.selectIntervalName) {
					return this.selectItem.intervals.map(x => x.intervalName);
				} else {
					return [];
				}
			},

			moneyArray() {
				if (this.selectMoney) {
					return this.selectItem.moneys.map(x => {
						let tmp = this.formatMoney(x.money)
						return `${x.name}(${tmp})`
					});
				} else {
					return [];
				}
			},
		},

		// watch: {
		// 	'model.money': function(newVal, oldVal) {
		// 		this.oldMoneyValue = newVal
		// 	},
		// },

		activated() {
			console.log('触发ctivated----')
			// let select = getState("select-item");
			let select = storage.session.get("select-item",{});
			console.log('select---',select)
			if (utils.isNotEmpty(select)) {
				this.selectItem = select;
				this.setModel();
			} else {
				this.$router.push({
					name: "home"
				});
			}
		},

		methods: {
			setModel() {
				this.model.count = 1;
				// 设置区间(下拉选项只有一个时默认选中第一个)
				if (Array.isArray(this.selectItem.intervals) && this.selectItem.intervals.length === 1) {
					this.model.range = this.selectItem.intervals[0].intervalId;
					this.model.rangeName = this.selectItem.intervals[0].intervalName;
				} else {
					this.model.range = null
					this.model.rangeName = ""
				}

				// 设置金额或单价（先判断是否可编辑，再判断是否为可选金额）
				if(this.editMoney) {
					this.model.money = ''
                    if (this.selectItem.maxMoney && this.selectItem.feeMode === 3) { // maxMoney不为空并且大于0才有意义
                        this.editMoneyPlaceholder = this.$t('choose_fee.maxMoneyStart') + this.$options.filters.formatMoney(this.selectItem.maxMoney) + this.$t('choose_fee.maxMoneyEnd')
                    } else {
                        this.editMoneyPlaceholder = this.$t('choose_fee.maxMoneyMust')
					}
					
				} else {
					this.model.money = this.selectItem.itemMoney
				}

				if (utils.isNotEmpty(this.selectItem.moneys)) {
					this.model.money = this.selectItem.moneys[0].money;
					this.model.name = this.selectItem.moneys[0].name;
				} 
				this.model.enableUseCompanyTitle = this.selectItem.enableUseCompanyTitle;
			},

			formatMoney(money) {
				return this.$options.filters.formatMoney(money)
			},

			selectRange() {
				this.showRangePicker = true;
			},

			onConfirm(value, index) {
				log('value', value, index)
				let v = this.selectItem.intervals;
				let item = v[index];
				this.defaultIndex = index;
				this.model.range = item.intervalId;
				this.model.rangeName = item.intervalName;
				this.showRangePicker = false;
			},

			selectPrice() {
				this.showMoneyPicker = true;
			},

			onConfirm2(value, index) {
				log('value2', value, index)
				let v = this.selectItem.moneys;
				let item = v[index];
				this.defaultIndex2 = index;
				this.model.money = item.money;
				this.model.name = item.name;
				this.showMoneyPicker = false;
			},

			onCommit() {
				let item = {
					intervalId: null,
					itemCount: this.model.count,
					itemId: this.selectItem.itemId,
					itemName: this.selectItem.itemName,
					// intervalName: this.intervalName,
					intervalName: this.model.rangeName,
					itemMoney: Number(this.model.money),
					nowMoney:this.sumMoney,
					itemRemark: this.model.remark
				};
				if(this.selectItem.intervals) {
					item.intervalId = this.model.range
				} else {
					item.intervalId = null
				}
				let param = {
					allMoney: this.sumMoney,
					chooseFee: item,
					pendFees:[item],
					enableUseCompanyTitle: this.model.enableUseCompanyTitle
				};
				apiChooseFee.check(param).then(res => {
					if (utils.isNotEmpty(res.data)) {
						let obj = {
							name: "pay-confirm",
							query: {
								type: 3,
								enableUseCompanyTitle:this.model.enableUseCompanyTitle
							}
						};
						// setState("pay-ticket", res.data);
						storage.session.set("pay-ticket", res.data);
						this.$router.push(obj);
					}
				});
			},

		},
	};
</script>

<style lang='scss' scoped>
	/*.flex-form-info {*/
	/*    padding: 5px;*/
	/*    display: flex;*/
	/*    justify-content: space-between;*/
	/*}*/

	/*.money-item {*/
	/*    color: #3b7a53;*/
	/*}*/

	// .input-border {
	// 	/deep/ .van-field__body {
	// 		border: 1px solid #005423;
	// 		border-radius: 5px;
	// 	}

	// 	/deep/ .van-cell {
	// 		padding: 0px;
	// 	}
	// }

	// .choose-fee-full {
	//     height: 100%;
	//     width: 100%;

	//     .content {
	//         height: 92%;
	//         overflow-y: auto;
	//         overflow-x: hidden;
	//     }

	//     .footer {
	//         max-height: 100px;
	//         height: 8%;
	//     }
	// }
</style>
